import { CheckOutlined } from '@mui/icons-material';
import { MIXTURE_STATUS_LABELS } from '../../constants/mixtures.constants';
import type { MaintenanceMixture } from '../../types';
import styles from './MixtureStatusBadge.module.css';

export const MixtureStatusBadge = ({ mixture }: { mixture: MaintenanceMixture }) =>
	mixture.status === 'confirmed' ? (
		<span className={`${styles.badge} ${styles.verified}`}>
			<CheckOutlined className={styles.icon} />
			{MIXTURE_STATUS_LABELS.confirmed}
		</span>
	) : (
		<span className={`${styles.badge} ${styles.suggested}`}>
			{MIXTURE_STATUS_LABELS[mixture.source]}
		</span>
	);
